import apiClient from './apiClient';

export interface DeptReportRow {
  f106_01: string; f106_11: string; f106_12: string; f106_16: boolean;
}
export interface ReportResponse { data: DeptReportRow[]; total: number; message?: string; }

export const deptReportApi = {
  async query(start = '', end = 'zzzz'): Promise<ReportResponse> {
    const res = await apiClient.get('/api/dept-report', { params: { start, end } });
    return res.data;
  },
};
